import CacheBase2 from '../../services/engines/CacheBase2';

/**
 * holds uml notes
 */
class UmlNotesCache extends CacheBase2 {
    initialize() {
        this._name = 'UmlSchemaCache';
    }
}

const umlNotesCache = new UmlNotesCache();
export default umlNotesCache;
